import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultGetItemAttributes = function defaultGetItemAttributes(item) {
  return item.attributes;
};
var defaultGetItemChecked = function defaultGetItemChecked(item) {
  return item.checked;
};
var defaultGetItemDisabled = function defaultGetItemDisabled(item) {
  return item.disabled;
};
var defaultGetItemGroupKey = function defaultGetItemGroupKey(item) {
  return item.groupKey;
};
var defaultGetItemLeftSide = function defaultGetItemLeftSide(item) {
  return item.leftSide;
};
var defaultGetItemRightSide = function defaultGetItemRightSide(item) {
  return item.rightSide;
};
var defaultGetItemKey = function defaultGetItemKey(item) {
  return item.key;
};
var defaultGetItemOnClick = function defaultGetItemOnClick(item) {
  return item.onClick;
};
var defaultGetItemRef = function defaultGetItemRef(item) {
  return item.ref;
};
var defaultGetItemDescription = function defaultGetItemDescription(item) {
  return item.description;
};
var defaultGetItemLabel = function defaultGetItemLabel(item) {
  return item.label;
};
var defaultGetItemTagName = function defaultGetItemTagName(item) {
  return item.tagName;
};
var defaultGetGroupKey = function defaultGetGroupKey(item) {
  return item.key;
};
var defaultGetGroupLabel = function defaultGetGroupLabel(item) {
  return item.label;
};
export var composePreparedProps = function composePreparedProps(props) {
  var _props$getItemAttribu, _props$getItemChecked, _props$getItemDisable, _props$getItemDescrip, _props$getItemGroupKe, _props$getItemKey, _props$getItemLeftSid, _props$getItemRightSi, _props$getItemOnClick, _props$getItemRef, _props$getItemLabel, _props$getItemTagName, _props$getGroupKey, _props$getGroupLabel;
  return _objectSpread(_objectSpread({}, props), {}, {
    getItemAttributes: (_props$getItemAttribu = props.getItemAttributes) !== null && _props$getItemAttribu !== void 0 ? _props$getItemAttribu : defaultGetItemAttributes,
    getItemChecked: (_props$getItemChecked = props.getItemChecked) !== null && _props$getItemChecked !== void 0 ? _props$getItemChecked : defaultGetItemChecked,
    getItemDisabled: (_props$getItemDisable = props.getItemDisabled) !== null && _props$getItemDisable !== void 0 ? _props$getItemDisable : defaultGetItemDisabled,
    getItemDescription: (_props$getItemDescrip = props.getItemDescription) !== null && _props$getItemDescrip !== void 0 ? _props$getItemDescrip : defaultGetItemDescription,
    getItemGroupKey: (_props$getItemGroupKe = props.getItemGroupKey) !== null && _props$getItemGroupKe !== void 0 ? _props$getItemGroupKe : defaultGetItemGroupKey,
    getItemKey: (_props$getItemKey = props.getItemKey) !== null && _props$getItemKey !== void 0 ? _props$getItemKey : defaultGetItemKey,
    getItemLeftSide: (_props$getItemLeftSid = props.getItemLeftSide) !== null && _props$getItemLeftSid !== void 0 ? _props$getItemLeftSid : defaultGetItemLeftSide,
    getItemRightSide: (_props$getItemRightSi = props.getItemRightSide) !== null && _props$getItemRightSi !== void 0 ? _props$getItemRightSi : defaultGetItemRightSide,
    getItemOnClick: (_props$getItemOnClick = props.getItemOnClick) !== null && _props$getItemOnClick !== void 0 ? _props$getItemOnClick : defaultGetItemOnClick,
    getItemRef: (_props$getItemRef = props.getItemRef) !== null && _props$getItemRef !== void 0 ? _props$getItemRef : defaultGetItemRef,
    getItemLabel: (_props$getItemLabel = props.getItemLabel) !== null && _props$getItemLabel !== void 0 ? _props$getItemLabel : defaultGetItemLabel,
    getItemTagName: (_props$getItemTagName = props.getItemTagName) !== null && _props$getItemTagName !== void 0 ? _props$getItemTagName : defaultGetItemTagName,
    getGroupKey: (_props$getGroupKey = props.getGroupKey) !== null && _props$getGroupKey !== void 0 ? _props$getGroupKey : defaultGetGroupKey,
    getGroupLabel: (_props$getGroupLabel = props.getGroupLabel) !== null && _props$getGroupLabel !== void 0 ? _props$getGroupLabel : defaultGetGroupLabel
  });
};